import { Badge, Text } from '../../shared/uiComponents';
import UserAction from '../../components/UserAction';

import './index.styles.scss';
import AccountDetails from '../../components/UserAction/accountDetails';
import { UserTie } from '../../shared/Assets/menuIcons';
import { UserProperties } from '../../redux/API/userAPIProperties';
import { AdminTypes } from '../Menu';
import { getBranchBadgeType } from '../../shared/Helpers/constants';

const MobileViewClientItem = ({ data, fetchUsers }: { data: UserProperties; fetchUsers: () => void }) => {
	const isAdmin = data.role?.section?.id === AdminTypes.admin;
	const branches = data.branches || [];

	return (
		<div className="clientItem" key={data.id}>
			<div className="clientItemHeader">
				<div className="clientItemTitle">
					<div className="clientItemAvatar">
						<UserTie />
					</div>
					<Text title={data.fullName} type="pmd" />
				</div>
				<Badge
					label={data.isDeactivated ? 'Inactive' : 'Active'}
					sizeType="md"
					type={data.isDeactivated ? 'gray' : 'success'}
				/>
			</div>
			<div className="clientItemBody">
				<div className="detailRow">
					<Text title="Email:" type="pxs" fontWeight="regular" className="label" />
					<Text title={data.email} type="psm" className="value" fontWeight="medium" />
				</div>
				<div className="detailRow">
					<Text title="Providers:" type="pxs" fontWeight="regular" className="label" />
					<Text title={`${data.numberOfClients}`} type="psm" className="value" fontWeight="medium" />
				</div>
				<div className="detailRow">
					<Text title="Parent phone:" type="pxs" fontWeight="regular" className="label" />
					<Text title={data.phoneNumber || '-'} type="psm" className="value" fontWeight="medium" />
				</div>
				{!isAdmin && branches.length > 0 && (
					<div className="detailRow">
						<Text title="Branches:" type="pxs" fontWeight="regular" className="label" />
						<div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
							{branches.map((branch) => (
								<Badge key={branch.id} label={branch.name} type={getBranchBadgeType(branch.state)} sizeType="sm" />
							))}
						</div>
					</div>
				)}
			</div>
			<div className="clientItemFooter">
				<div className="actionsSlot">
					<UserAction item={data} fetchUsers={fetchUsers} hideMoreInfo />
				</div>
				<div className="viewMoreButton">
					<AccountDetails item={data} showMoreInfoButton />
				</div>
			</div>
		</div>
	);
};

export default MobileViewClientItem;
